import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext/ThemeProvider';
import { AuthProvider } from './contexts/AuthContext/AuthProvider';
import { NotifyProvider } from './contexts/NotifyContext';
import { VersionCheckProvider } from './contexts/VersionCheckContext';

import pkg from '../package.json';
import App from './App'
import './main.css'
import { IASMAProvider } from './contexts/IASMAContext';
import AppMenu from './test/AppMenu';

const CURRENT_VERSION = pkg.version;

// createRoot(document.getElementById('root')!).render(<AppMenu />);
createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <ThemeProvider defaultTheme="solar">
      <NotifyProvider>
        <VersionCheckProvider currentVersion={CURRENT_VERSION}>
          <AuthProvider>
            <IASMAProvider>
              <App />
            </IASMAProvider>
          </AuthProvider>
        </VersionCheckProvider>
      </NotifyProvider>
    </ThemeProvider>
  </BrowserRouter>,
)
